import { categoryTheme } from "@/lib/blog";
import { cn } from "@/lib/utils";

/** Farbiges Kategorie-Badge (Farben konsistent zum Ratgeber-Menü). */
export default function CategoryBadge({
  slug,
  name,
  className,
}: {
  /** Kategorie-Slug, bestimmt die Farbe. */
  slug: string;
  /** Anzeigename aus dem CMS, z. B. „Zulassungs-Guide". */
  name: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider",
        categoryTheme(slug).badge,
        className
      )}
    >
      {name}
    </span>
  );
}
